import LxpLayout from "@/views/layout/lxp/LxpLayout";
import LxpMobileLayoutV2 from "@/views/layout/lxp/mobile/LxpMobileLayoutV2";
import navigationUtils from "@/assets/js/navigationUtils";

const isMobile = navigationUtils.any();

const promotionRoutes = [
    {
        path: '/promotion',
        component: isMobile ? LxpMobileLayoutV2: LxpLayout,
        children: [
            {
                path: ':distCrseSn',
                name: "Promotion",
                component: () => isMobile ? import('../../views/pages/promotion/mobile/MobilePromotion.vue') : import('../../views/pages/promotion/Promotion.vue'),
            }
        ],
    }
];

export const setPromotionRoutes = (routes) => {
    routes.push(...promotionRoutes);
}